import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Importa las traducciones
import translationEN from './i18n/en.json';
import translationES from './i18n/es.json';
import translationCAT from './i18n/cat.json';

// Define las traducciones
const resources = {
  en: {
    translation: translationEN,
  },
  es: {
    translation: translationES,
  },
  cat: {
    translation: translationCAT,
  },
};

i18n
  .use(initReactI18next) // Pasa i18n a react-i18next
  .init({
    resources,
    lng: localStorage.getItem('language') || 'cat', // Idioma por defecto
    fallbackLng: 'cat',
    interpolation: {
      escapeValue: false, // React ya maneja el escape por defecto
    },
  });

export default i18n;